import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import {
  createMallBanner,
  getMallBannerById,
  getMallList,
  updateMallBanner,
  uplaodBannerMedia,
} from 'app/api/mall';
import {
  bannerValidationRules,
  validate,
} from 'app/constants/validation-constants';
import Message from 'app/utils/Message';
import Toast from 'app/utils/Toast';

const useCreateMallBanner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mallList, setMallList] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);

  const [error, setErrors] = useState({});
  const [values, setValues] = useState({
    img_type: '',
    // Preselect the mall the user was already viewing on the banner list.
    // In edit mode loadStoreData overwrites this with the saved value.
    mall_id: location?.state?.mall_id || '',
    sequence: null,
    img_url: '',
    status: true,
    // Optional link URL (BL-09). Hydrated from the server below; a stored
    // null becomes '' here so the input is always a controlled string.
    url: '',
  });

  const bannerId = location?.state?.id ? location?.state?.id : '';

  useEffect(() => {
    getMallListforDropdown();
    if (bannerId) {
      loadStoreData(bannerId);
    }
  }, [bannerId]);

  async function loadStoreData(id) {
    if (!id) {
      return;
    }

    setPageLoading(true);
    let response = await getMallBannerById(id);
    setPageLoading(false);
    if (response?.responseCode === 200) {
      let responsedata = response?.data;

      setValues(() => ({
        img_type: responsedata?.img_type,
        mall_id: responsedata?.mall_id,
        sequence: responsedata?.sequence,
        img_url: responsedata?.img_url,
        status: responsedata?.status,
        url: responsedata?.url ?? '',
      }));
    } else {
      Toast.error(
        response?.data ? response?.data : Message.Error.COMMON_MESSAGE
      );
    }
  }
  const getMallListforDropdown = async () => {
    setPageLoading(true);
    let response = await getMallList(1);
    setPageLoading(false);
    if (response && response?.responseCode === 200) {
      let temp = await response?.data?.malls?.map((item, index) => {
        return {
          ...item,
          value: item.id,
          label: item.name,
        };
      });
      setMallList(temp);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message?.Error?.COMMON_MESSAGE
      );
    }
  };

  async function callAddOrUpdateAPI() {
    setPageLoading(true);
    let response = {};

    let senddata = {
      ...values,
      // Always sent, even when blank — an empty string is how the backend
      // clears a stored url (260717-k0z rule: undefined keeps the stored
      // value, '' clears it to null). This form always holds a string, so
      // it is always sent, never omitted.
      url: (values.url || '').trim(),
      name: values.mallName,
      bannerId: bannerId,
    };

    if (bannerId) {
      response = await updateMallBanner(senddata);
    } else {
      response = await createMallBanner(senddata);
    }
    setPageLoading(false);
    if (response?.responseCode === 200) {
      Toast.success(
        bannerId
          ? Message.MallBanner.UPDATED_SUCCESS
          : Message.MallBanner.CREATED_SUCCESS
      );
      navigate(`/mall-banner`, {
        state: {
          mall_id: values.mall_id,
        },
      });
      //navigate(-1);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message?.Error?.COMMON_MESSAGE
      );
    }
  }
  function handleCreateMall(e) {
    e.preventDefault();
    const validationErrors = validate(values, bannerValidationRules);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      callAddOrUpdateAPI();
    }
  }

  function setChange(name, val) {
    setValues((prevState) => ({
      ...prevState,
      [name]: val,
    }));
    setErrors({
      ...error,
      [name]: '',
    });
  }

  async function uploadMediaHandler(file, name, isImage) {
    if (!values.img_type) {
      Toast.error('Please Select Banner type');
      setChange(name, null);
      return;
    }

    if (!file) {
      // If the file is null, it means the user clicked the remove button
      setChange(name, null);
      return;
    }

    const response = await uplaodBannerMedia(file);
    if (response.responseCode === 200) {
      Toast.success(`${isImage ? 'Image' : 'Video'} upload Successfull`);

      const data = await response.data;
      setChange(name, data?.url);
    } else {
      setChange(name, null);

      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  }
  function handleChange(e) {
    if (e && e.target) {
      const { name, value } = e.target;
      setValues({
        ...values,
        [name]: value,
      });

      if (error[name]) {
        setErrors({
          ...error,
          [name]: '',
        });
      }
    }
  }

  return {
    values,
    error,
    handleCreateMall,
    pageLoading,
    mallList,
    uploadMediaHandler,
    setChange,
    bannerId,
    handleChange,
    navigate,
  };
};

export default useCreateMallBanner;
